import { render, staticRenderFns } from "./UploadImageFileOrUrl.vue?vue&type=template&id=ad5ab724&scoped=true&"
import script from "./UploadImageFileOrUrl.vue?vue&type=script&lang=ts&"
export * from "./UploadImageFileOrUrl.vue?vue&type=script&lang=ts&"
import style0 from "./UploadImageFileOrUrl.vue?vue&type=style&index=0&id=ad5ab724&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad5ab724",
  null
  
)

export default component.exports